<template>
    <div class="JoinUsPage">正在等待开启...</div>
</template>

<script src="./_JoinUsPage.js" lang="js"></script>
<style src="./_JoinUsPage.less" lang="less" scoped></style>
